import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vModelRadio as _vModelRadio, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-51f9c599")

_pushScopeId("data-v-51f9c599")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "text-muted fs-8 mb-3" }, " This feature uses your AI credits based on usage. Generated images are reviewed for company compliance before you can attach them. ", -1)
const _hoisted_2 = {
  key: 0,
  class: "alert alert-warning mb-4"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Add AI credits")
const _hoisted_4 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("label", { class: "form-label fw-semibold" }, "Platforms", -1)
const _hoisted_6 = { class: "d-flex flex-wrap gap-2" }
const _hoisted_7 = { class: "mb-4" }
const _hoisted_8 = /*#__PURE__*/_createVNode("label", { class: "form-label fw-semibold required" }, "What this image is for", -1)
const _hoisted_9 = { class: "mb-4" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", { class: "form-label fw-semibold" }, "Reference photos", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("p", { class: "text-muted fs-8 mb-2" }, "Optional — upload up to 3 images to guide the result.", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("i", { class: "far fa-image me-1" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Add reference photos ")
const _hoisted_14 = {
  key: 0,
  class: "d-flex flex-wrap gap-2 mb-3"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_16 = {
  key: 1,
  class: "form-check mb-3"
}
const _hoisted_17 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label fs-8",
  for: "rightsConfirm"
}, " I have the right to use these photos. ", -1)
const _hoisted_18 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("label", { class: "form-label fw-semibold mb-1" }, "How should we use your photos?", -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("p", { class: "text-muted fs-8 mb-3" }, [
  /*#__PURE__*/_createTextVNode(" Choose one. This tells the AI whether to keep your product from the photo, or only borrow the look and feel. Not sure? Pick "),
  /*#__PURE__*/_createVNode("strong", null, "Same product, new scene"),
  /*#__PURE__*/_createTextVNode(" if your photo shows your product. ")
], -1)
const _hoisted_21 = { class: "d-flex flex-column gap-2" }
const _hoisted_22 = /*#__PURE__*/_createVNode("span", { class: "flex-grow-1" }, [
  /*#__PURE__*/_createVNode("span", { class: "fw-semibold d-block" }, "Same product, new scene"),
  /*#__PURE__*/_createVNode("span", { class: "text-muted fs-8 d-block" }, " Use when your photo shows your product, bottle, box, or packaging. The AI keeps that item recognizable and creates a new background, lighting, or setting. "),
  /*#__PURE__*/_createVNode("span", { class: "suggest-post-image-dialog__mode-example" }, " Example: Your supplement bottle on a table → same bottle on a sunny kitchen counter. ")
], -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("span", { class: "flex-grow-1" }, [
  /*#__PURE__*/_createVNode("span", { class: "fw-semibold d-block" }, "Similar look, not the same photo"),
  /*#__PURE__*/_createVNode("span", { class: "text-muted fs-8 d-block" }, " Use for inspiration only — colors, lighting, and lifestyle feel. The AI will not recreate the exact photo, faces, or logos. "),
  /*#__PURE__*/_createVNode("span", { class: "suggest-post-image-dialog__mode-example" }, " Example: A warm golden-hour photo → a new image with similar warm tones and calm mood. ")
], -1)
const _hoisted_24 = { class: "mb-2" }
const _hoisted_25 = /*#__PURE__*/_createVNode("label", { class: "form-label fw-semibold mb-1" }, "How many images?", -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("p", { class: "text-muted fs-8 mb-3" }, " Choose one. More images use more AI credits. ", -1)
const _hoisted_27 = { class: "d-flex flex-column gap-2" }
const _hoisted_28 = { class: "flex-grow-1" }
const _hoisted_29 = { class: "fw-semibold d-block" }
const _hoisted_30 = { class: "text-muted fs-8 d-block" }
const _hoisted_31 = { key: 2 }
const _hoisted_32 = /*#__PURE__*/_createVNode("div", { class: "text-muted fs-8 mb-3" }, " Pick an image to attach to your post. You can still edit the caption before publishing. ", -1)
const _hoisted_33 = { class: "row g-3" }
const _hoisted_34 = { class: "card suggest-post-image-dialog__result card h-100" }
const _hoisted_35 = { class: "card-body p-2" }
const _hoisted_36 = {
  key: 0,
  class: "text-muted fs-8 mt-3"
}
const _hoisted_37 = { key: 0 }
const _hoisted_38 = /*#__PURE__*/_createVNode("i", { class: "fas fa-spinner fa-spin me-1" }, null, -1)
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" Generating… ")
const _hoisted_40 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.visible = $event)),
    title: "Suggest post image",
    width: "560px",
    "destroy-on-close": "",
    onClosed: _ctx.onClosed
  }, {
    footer: _withId(() => [
      _createVNode("button", {
        type: "button",
        class: "btn btn-light",
        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
      }, " Cancel "),
      (!_ctx.images.length)
        ? (_openBlock(), _createBlock("button", {
            key: 0,
            type: "button",
            class: "btn btn-primary ms-2",
            disabled: _ctx.generating || !_ctx.canGenerate,
            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.generate && _ctx.generate(...args)))
          }, [
            (_ctx.generating)
              ? (_openBlock(), _createBlock("span", _hoisted_37, [
                  _hoisted_38,
                  _hoisted_39
                ]))
              : (_openBlock(), _createBlock("span", _hoisted_40, "Suggest image"))
          ], 8, ["disabled"]))
        : (_openBlock(), _createBlock("button", {
            key: 1,
            type: "button",
            class: "btn btn-light-primary ms-2",
            disabled: _ctx.generating,
            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.regenerate && _ctx.regenerate(...args)))
          }, " Try again ", 8, ["disabled"]))
    ]),
    default: _withId(() => [
      _hoisted_1,
      (_ctx.creditsError)
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            _createTextVNode(_toDisplayString(_ctx.creditsError) + " ", 1),
            _createVNode(_component_router_link, {
              to: "/settings/ai247-portal",
              class: "fw-bold ms-1"
            }, {
              default: _withId(() => [
                _hoisted_3
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (!_ctx.images.length)
        ? (_openBlock(), _createBlock("form", {
            key: 1,
            onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.generate && _ctx.generate(...args)), ["prevent"]))
          }, [
            (_ctx.platformLabels.length)
              ? (_openBlock(), _createBlock("div", _hoisted_4, [
                  _hoisted_5,
                  _createVNode("div", _hoisted_6, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.platformLabels, (label) => {
                      return (_openBlock(), _createBlock("span", {
                        key: label,
                        class: "badge badge-light-primary"
                      }, _toDisplayString(label), 1))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_7, [
              _hoisted_8,
              _withDirectives(_createVNode("textarea", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.prompt = $event)),
                class: "form-control",
                rows: "4",
                placeholder: _ctx.promptPlaceholder,
                required: ""
              }, null, 8, ["placeholder"]), [
                [_vModelText, _ctx.form.prompt]
              ])
            ]),
            _createVNode("div", _hoisted_9, [
              _hoisted_10,
              _hoisted_11,
              _createVNode("input", {
                ref: "referenceInput",
                type: "file",
                accept: "image/*",
                multiple: "",
                class: "d-none",
                onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onReferenceFilesSelected && _ctx.onReferenceFilesSelected(...args)))
              }, null, 544),
              _createVNode("button", {
                type: "button",
                class: "btn btn-sm btn-light mb-3",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.triggerReferencePicker && _ctx.triggerReferencePicker(...args)))
              }, [
                _hoisted_12,
                _hoisted_13
              ]),
              (_ctx.referenceFiles.length)
                ? (_openBlock(), _createBlock("div", _hoisted_14, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.referenceFiles, (item, index) => {
                      return (_openBlock(), _createBlock("div", {
                        key: index,
                        class: "suggest-post-image-dialog__ref-thumb"
                      }, [
                        _createVNode("img", {
                          src: item.previewUrl,
                          alt: "Reference preview"
                        }, null, 8, ["src"]),
                        _createVNode("button", {
                          type: "button",
                          class: "suggest-post-image-dialog__ref-remove",
                          "aria-label": "Remove reference",
                          onClick: ($event: any) => (_ctx.removeReferenceFile(index))
                        }, [
                          _hoisted_15
                        ], 8, ["onClick"])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.referenceFiles.length)
                ? (_openBlock(), _createBlock("div", _hoisted_16, [
                    _withDirectives(_createVNode("input", {
                      id: "rightsConfirm",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.rightsConfirmed = $event)),
                      class: "form-check-input",
                      type: "checkbox"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.form.rightsConfirmed]
                    ]),
                    _hoisted_17
                  ]))
                : _createCommentVNode("", true)
            ]),
            (false && _ctx.referenceFiles.length)
              ? (_openBlock(), _createBlock("div", _hoisted_18, [
                  _hoisted_19,
                  _hoisted_20,
                  _createVNode("div", _hoisted_21, [
                    _createVNode("label", {
                      class: ["suggest-post-image-dialog__mode-option", { 'suggest-post-image-dialog__mode-option--active': _ctx.form.referenceMode === 'keep_product' }]
                    }, [
                      _withDirectives(_createVNode("input", {
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.referenceMode = $event)),
                        type: "radio",
                        class: "form-check-input mt-1 flex-shrink-0",
                        value: "keep_product"
                      }, null, 512), [
                        [_vModelRadio, _ctx.form.referenceMode]
                      ]),
                      _hoisted_22
                    ], 2),
                    _createVNode("label", {
                      class: ["suggest-post-image-dialog__mode-option", { 'suggest-post-image-dialog__mode-option--active': _ctx.form.referenceMode === 'match_mood' }]
                    }, [
                      _withDirectives(_createVNode("input", {
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.referenceMode = $event)),
                        type: "radio",
                        class: "form-check-input mt-1 flex-shrink-0",
                        value: "match_mood"
                      }, null, 512), [
                        [_vModelRadio, _ctx.form.referenceMode]
                      ]),
                      _hoisted_23
                    ], 2)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_24, [
              _hoisted_25,
              _hoisted_26,
              _createVNode("div", _hoisted_27, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.variationOptions, (option) => {
                  return (_openBlock(), _createBlock("label", {
                    key: option.count,
                    class: ["suggest-post-image-dialog__mode-option", { 'suggest-post-image-dialog__mode-option--active': _ctx.form.variationCount === option.count }]
                  }, [
                    _withDirectives(_createVNode("input", {
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.variationCount = $event)),
                      type: "radio",
                      class: "form-check-input mt-1 flex-shrink-0",
                      value: option.count
                    }, null, 8, ["value"]), [
                      [
                        _vModelRadio,
                        _ctx.form.variationCount,
                        void 0,
                        { number: true }
                      ]
                    ]),
                    _createVNode("span", _hoisted_28, [
                      _createVNode("span", _hoisted_29, _toDisplayString(option.title), 1),
                      _createVNode("span", _hoisted_30, _toDisplayString(option.description), 1)
                    ])
                  ], 2))
                }), 128))
              ])
            ])
          ], 32))
        : (_openBlock(), _createBlock("div", _hoisted_31, [
            _hoisted_32,
            _createVNode("div", _hoisted_33, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.images, (image, index) => {
                return (_openBlock(), _createBlock("div", {
                  key: index,
                  class: "col-6"
                }, [
                  _createVNode("div", _hoisted_34, [
                    _createVNode("img", {
                      src: image.previewUrl,
                      class: "card-img-top suggest-post-image-dialog__result-img",
                      alt: `Generated image ${index + 1}`
                    }, null, 8, ["src", "alt"]),
                    _createVNode("div", _hoisted_35, [
                      _createVNode("button", {
                        type: "button",
                        class: "btn btn-sm btn-primary w-100",
                        onClick: ($event: any) => (_ctx.useImage(image))
                      }, " Use this ", 8, ["onClick"])
                    ])
                  ])
                ]))
              }), 128))
            ]),
            (_ctx.creditsRemaining != null)
              ? (_openBlock(), _createBlock("div", _hoisted_36, " AI credits remaining: " + _toDisplayString(_ctx.creditsRemaining), 1))
              : _createCommentVNode("", true)
          ]))
    ]),
    _: 1
  }, 8, ["modelValue", "onClosed"]))
})